import * as React from "react";
import { Instagram, Mail, MapPin, Phone, ArrowRight, ExternalLink } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const socialPosts = [{
  id: "post-1",
  platform: "nm on Instagram",
  handle: "@babebloombarco",
  image: "https://babebloombarco.com/wp-content/uploads/2026/08/1CD047BE-A531-4879-B363-8766D4C996D3_1_105_c.jpeg?v=4z365hrppmw",
  text: "Behind every beautiful event is intentional prep \xA0\n\n\nFrom selecting fresh stems to organizing every detail, we make sure your flower bar is ready to impress before your guests even arrive \xA0\n\n\nThis isn’t just setup—it’s creating an experience your guests will remember \xA0\n\n\nIf you’re planning a bridal shower, party, or special event, make it unforgettable \xA0\nNow booking \xA0\n\n\n Message our page to book\xA0\n +1 (931) 368-8439\xA0\n babebloombarco@gmail.com\xA0",
  date: "1 day ago",
  link: "https://instagram.com"
}, {
  id: "post-3",
  platform: "Instagram",
  handle: "@babebloombarco",
  image: "https://babebloombarco.com/wp-content/uploads/2026/08/1C26C596-8227-48D8-845F-5517266D375F_1_105_c.jpeg?v=7u37wryur0n",
  text: "May was full of blooms, beautiful people, and the sweetest memories \n\n\nFrom our very first pop-ups to watching everyone create bouquets made just for them, Babe Bloom Bar Co. is slowly becoming everything we dreamed of and more \n\n\nEvery bouquet tells a story, and we’re so grateful for every person who has supported, shared, stopped by, or bloomed with us so far \n\n\nNext stop:\n Goldie & Bird Coastal Pop-Up\n Saturday, June 6\n 10AM–3PM\n\n\nCome build your own bouquet by the sea with us ",
  date: "1 week ago",
  link: "https://instagram.com"
}, {
  id: "post-4",
  platform: "Instagram",
  handle: "@babebloombarco",
  image: "https://babebloombarco.com/wp-content/uploads/2026/06/IMG_6481-scaled.jpg?v=lwqa03tp4q",
  text: "There’s something so special about watching everyone create bouquets that reflect their own style \n\n\n\xA0— we only sell bouquets during pop-ups! \xA0\xA0\n\n\nThank you to all the beautiful ladies who stopped by and bloomed with us this weekend  We loved seeing every bouquet come to life!",
  date: "2 weeks ago",
  link: "https://instagram.com"
}];
export default function ReachOut() {
  return <section data-section-id="233620" id="reach-out" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col space-y-10">
            <div className="space-y-6">
              <h2 className="font-default text-7xl md:text-8xl lg:text-9xl font-bold tracking-tighter text-primary leading-none">
                Connect.
              </h2>
              <p className="text-xl md:text-2xl text-muted-foreground max-w-md font-serif">
                Let's bring the beauty of fresh blooms to your next celebration. Reach out to reserve your luxury flower bar experience.
              </p>
            </div>

            <div className="flex flex-col space-y-6 pt-8 border-t border-secondary/30">
              <div className="flex items-start space-x-4 group">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                  <MapPin className="lucide lucide-map-pin w-6 h-6 !text-[rgba(245,123,168,1)]" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-lg text-foreground">Service Area</h3>
                  <p className="text-muted-foreground">Clarksville, Nashville, Fort Campbell, Hopkinsville, Middle Tennessee, Southern Kentucky</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                  <Phone className="lucide lucide-phone w-6 h-6 !text-[rgba(245,123,168,1)]" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-lg text-foreground">Call Us</h3>
                  <p className="text-muted-foreground">
                    <Link to="tel:9313688439" className="hover:text-primary transition-colors">
                      (931) 368-8439
                    </Link>
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 group">
                <div className="bg-secondary/10 p-3 rounded-lg text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                  <Mail className="lucide lucide-mail w-6 h-6 !text-[rgba(245,123,168,1)]" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-lg text-foreground">Email Us</h3>
                  <p className="text-muted-foreground">
                    <Link to="mailto:babebloombarco@gmail.com" className="hover:text-primary transition-colors">
                      babebloombarco@gmail.com
                    </Link>
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <Button size="lg" className="w-full sm:w-auto group bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg" asChild>
                <Link to="/ContactPage">
                  Inquire About Your Event
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative">
            {}
            <div className="absolute -inset-4 bg-primary/5 rounded-3xl blur-3xl -z-10"></div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {socialPosts.map((post, i) => <div data-index={i} key={post.id} className={`flex flex-col ${i % 2 !== 0 ? 'sm:mt-12' : ''}`}>
                  <Card className="h-full border-secondary/20 shadow-md hover:shadow-lg transition-all duration-300 bg-card/50 backdrop-blur-xl group rounded-lg">
                    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
                      <div className="flex items-center space-x-2">
                        <Instagram className="lucide lucide-instagram w-5 h-5 text-primary" />
                        
                      </div>
                      <Link to={post.link} newTab className="text-muted-foreground hover:text-primary transition-colors">
                        <ExternalLink className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                        <span className="sr-only">View on {post.platform}</span>
                      </Link>
                    </CardHeader>
                    
                    {post.image && <div className="relative w-full aspect-square overflow-hidden">
                        <img src={post.image} alt={`Luxury floral display from ${post.platform}`} className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500" />
                      </div>}
                    
                    <CardContent className={`pt-4 ${!post.image ? 'flex-grow flex items-center' : ''}`}>
                      <p className="text-sm text-foreground/80 line-clamp-4 font-default">
                        {post.text}
                      </p>
                    </CardContent>
                    
                    <CardFooter className="pt-0 mt-auto">
                      <span className="text-xs uppercase tracking-widest font-medium text-primary">
                        {post.date}
                      </span>
                    </CardFooter>
                  </Card>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}